export type MembershipCheck = {
  userId: string;
  hasCurrent: boolean;
} | null;

export function resolveMembershipUi(
  authReady: boolean,
  sessionUserId: string | null,
  membershipCheck: MembershipCheck,
) {
  const hasCurrentMembership =
    Boolean(sessionUserId) &&
    (membershipCheck?.userId !== sessionUserId ||
      (membershipCheck?.hasCurrent ?? true));
  const membershipReady =
    !sessionUserId || membershipCheck?.userId === sessionUserId;

  return {
    hasCurrentMembership,
    showJoinPrompt:
      authReady && membershipReady && !hasCurrentMembership,
  };
}
